import { Logo } from "@/pages/home/components/Navbar";

const FOOTER_NAV = [
  { href: "#hot", label: "今日热搜" },
  { href: "#features", label: "焦点大瓜" },
  { href: "#channels", label: "栏目分类" },
  { href: "#talk", label: "网友热议" },
  { href: "#mood", label: "群众态度" },
];

const FOOTER_HELP = [
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于本站" },
  { href: "#submit", label: "投稿线索" },
  { href: "#submit", label: "投诉与举报" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-primary-50">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-[1.5fr_1fr_1fr_1.2fr]">
          <div>
            <div className="[&_span]:text-primary-50">
              <Logo />
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-primary-100/80">
              搜罗本月最热的大瓜围观现场，聚合网友热议评论与群众反应，和你一起追更、讨论、理性吃瓜。
            </p>
            <div className="mt-5 flex gap-2.5">
              {[
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-bilibili-line", label: "哔哩哔哩" },
                { icon: "ri-remixicon-line", label: "公众号" },
                { icon: "ri-qq-line", label: "QQ" },
              ].map((s) => (
                <a
                  key={s.label}
                  href="#top"
                  aria-label={s.label}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-800/60 text-primary-50 transition-colors hover:bg-accent-500"
                >
                  <i className={s.icon} />
                </a>
              ))}
            </div>
          </div>

          <nav aria-label="内容导航">
            <h4 className="text-sm font-semibold text-primary-50">内容导航</h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-primary-100/80">
              {FOOTER_NAV.map((l) => (
                <li key={l.href + l.label}>
                  <a href={l.href} className="transition-colors hover:text-accent-300">{l.label}</a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="帮助中心">
            <h4 className="text-sm font-semibold text-primary-50">帮助中心</h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-primary-100/80">
              {FOOTER_HELP.map((l) => (
                <li key={l.href + l.label}>
                  <a href={l.href} className="transition-colors hover:text-accent-300">{l.label}</a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h4 className="text-sm font-semibold text-primary-50">理性吃瓜 · 共建好氛围</h4>
            <p className="mt-4 text-sm leading-relaxed text-primary-100/80">
              想加入选题共创，或提供独家大瓜线索？
              <br />
              留下你的想法，编辑部会在 24 小时内查看。
            </p>
            <a
              href="#submit"
              className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
            >
              我要投稿 / 提建议 <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>

        <div className="mt-10 border-t border-primary-800/70 pt-6">
          <p className="text-xs leading-relaxed text-primary-100/60">
            免责声明：本站热搜榜、网友热议、群众反应与部分讨论聚合内容主要呈现围观氛围，相关内容仅代表发言网友个人观点，不代表本站立场；我们倡导理性吃瓜、不造谣不传谣、尊重当事人与个人隐私。
          </p>
          <div className="mt-4 flex flex-col gap-2 text-xs text-primary-100/70 sm:flex-row sm:items-center sm:justify-between">
            <p>© {new Date().getFullYear()} 本月大瓜 · 保留所有权利</p>
            <p className="flex items-center gap-2">
              <a href="#top" className="inline-flex items-center gap-1 transition-colors hover:text-accent-300">
                <i className="ri-arrow-up-line" /> 回到顶部
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}